import {BitrixVue} from 'ui.vue3'
import store from 'ms.vuex_store'

import authForm from './component/auth-form'

export class AuthForm
{
	constructor(nodeId, signedParameters, componentName) {
		this.rootNode = document.querySelector(nodeId)
		this.signedParameters = signedParameters
		this.componentName = componentName
	}

	getSignedParams() {
		return this.signedParameters
	}

	getComponentName() {
		return this.componentName
	}
	init() {
		const context = this;

		const application = BitrixVue.createApp({
			components: {
				authForm
			},
			beforeCreate() {
				this.$bitrix.Application.set(context);
			},
			template: '<authForm />'
		})
		application.use(store)
		application.mount(this.rootNode)
	}
}